/* globals $ */
(function() {
    'use strict';

    angular
        .module('quantixApp')
        .directive('crSlider', crisilSlider);

    function crisilSlider () {
        var directive = {
            restrict: 'E',
            scope: {
                minValue: '=',
                maxValue: '=',
				dataprovider: '=',
				action: '&'
            },
            controller: ['$scope', function ($scope) {
            	var vm = this;
                function init() {
					vm.items = angular.copy($scope.dataprovider);
					vm.minValue = $scope.maxValue;
					vm.maxValue = $scope.minValue;
					vm.options = {
						stepsArray: vm.items,
						onChange: function(id, newValue, highValue, pointerType) {
							console.info('Changed Custom Slider : ', id, newValue, pointerType);
							//$scope.$parent.minValue = highValue;
							$scope.$parent.maxValue = newValue;
							//$scope.minValue = highValue;
							$scope.maxValue = newValue;
							//$scope.action($scope.minValue, $scope.maxValue);
							//$scope.action();
						},
						showTicksValues: true,
					
					}
				};
				init();
            	
              }],
              controllerAs: 'ctrl',
             //template: 	'<rzslider rz-slider-model = "ctrl.minValue" rz-slider-high = "ctrl.maxValue" rz-slider-options = "ctrl.options"></rzslider>'
             template: 	'<rzslider rz-slider-high = "ctrl.maxValue" rz-slider-options = "ctrl.options"></rzslider>'
        };

        return directive;
    }
})();


